import drake from './drake';
import marshmello from './marshmello';
import biebz from './biebz';
import ariana from './ariana';

export default {
  drake,
  biebz,
  marshmello,
  ariana
};



// WEBPACK FOOTER //
// ./src/utils/data/index.js